<template>
    <div class="c-settings-select">
        <div
            class="dropdown d-flex align-items-center gap-0-5"
            :class="{ show: active }"
        >
            <span class="d-md-none d-lg-inline-block">{{ text }}</span>
            <button
                @click.stop="active = !active"
                class="btn btn-text text-primary p-0"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <template v-if="selected">{{ selected }}</template>
                <template v-else>{{ options[0].label }}</template>
                <a-icon icon="Dropdown" />
            </button>
            <div
                v-if="active"
                v-click-outside="closeDropdown"
                class="dropdown-menu dropdown-menu-right"
                :class="{ show: active }"
            >
                <button
                    v-for="(option, id) in options"
                    class="dropdown-item text-sm"
                    type="button"
                    :key="id"
                    @click="
                        active = !active
                        sort.by = option.query
                        selected = option.label
                    "
                >
                    {{ option.label }}
                </button>
            </div>
        </div>
        <div class="c-settings-sort">
            <button
                class="c-settings-sort__btn"
                :class="[sort.direction === 'asc' ? 'is-active' : '']"
                data-toggle="tooltip"
                data-placement="top"
                title="Rosnąco"
                @click="sort.direction = 'asc'"
            >
                <a-icon icon="SortUp" />
                <span class="sr-only">Rosnąco</span>
            </button>
            <button
                @click="sort.direction = 'desc'"
                class="c-settings-sort__btn"
                :class="[sort.direction === 'desc' ? 'is-active' : '']"
                data-toggle="tooltip"
                data-placement="top"
                title="Malejąco"
            >
                <a-icon icon="SortDown" />
                <span class="sr-only">Malejąco</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: false,
            selected: null
        }
    },
    props: {
        text: {
            type: String,
            default: 'Sortuj po:'
        },
        options: {
            type: Array,
            required: true
        },
        moduleName: {
            type: String,
            required: false
        },
        currentSort: {
            type: Object,
            required: false
        }
    },
    created() {
        this.selected =
            this.options.find(el => el.query === this.sort.by) &&
            this.options.find(el => el.query === this.sort.by).label
    },
    methods: {
        closeDropdown() {
            this.active = !this.active
        },
        async setSort() {
            const { moduleName, $store } = this

            const module = `${moduleName
                .charAt(0)
                .toUpperCase()}${moduleName.slice(1)}`

            if ($store._actions[`set${module}Sort`]) {
                await $store.dispatch(`set${module}Sort`, this.sort)
            }

            if ($store._actions[`${moduleName}Fetch`]) {
                await $store.dispatch(`${moduleName}Fetch`, {})
            }

            this.$emit('onChange')
            this.$emit('on-change')
        }
    },
    computed: {
        sort() {
            const { currentSort, moduleName, $store } = this

            if (currentSort) {
                return currentSort
            }

            const getter = `get${moduleName.charAt(0).toUpperCase() + moduleName.slice(1)}Sort`
            return $store.getters[getter]
        }
    },
    watch: {
        'sort.by'() {
            this.selected = this.options.find(
                el => el.query === this.sort.by
            ).label
            this.setSort()
        },
        'sort.direction'() {
            this.setSort()
        }
    }
}
</script>
